import { ERewardCalendarBadgeInternalViewModel } from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultRewardCalendarBadge: BlockMetadata = {
  id: ERewardCalendarBadgeInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/reward-calendar/default_badge.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: () => null
};

export const rewardCalendarBadgesDesigns = {
  defaultRewardCalendarBadge
};

export const rewardCalendarBadgesDesignsByTheme: Record<
  EThemes,
  BlockMetadata[]
> = Object.values(rewardCalendarBadgesDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, BlockMetadata[]>
);
